import React, { useState } from 'react';
import '../styles/Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="header">
      <div className="header-container">
        <a href="#home" className="logo-link" onClick={closeMenu}>
          <img src="/logo.jpg" alt="Літо -- благодійна організація" className="logo" />
        </a>
        <button
          className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}
          aria-label="Toggle menu"
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen((prev) => !prev)}
        >
          <span />
          <span />
          <span />
        </button>
        <div className={`header-actions ${isMenuOpen ? 'open' : ''}`}>
          <nav className="nav">
            <a href="#home" className="nav-link" onClick={closeMenu}>Головна</a>
            <a href="#about" className="nav-link" onClick={closeMenu}>Про нас</a>
            <a href="#projects" className="nav-link" onClick={closeMenu}>Проєкти</a>
            <a href="#join" className="nav-link" onClick={closeMenu}>Доєднатись</a>
            <a href="#contacts" className="nav-link" onClick={closeMenu}>Контакти</a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
